<template>
    <div>
        <section
            class="section section--slate050 section--slim section--overflowVisible"
        >
            <HeroBanner
                :header="dataHeroBanner.header"
                :image="dataHeroBanner.image"
                reverse-img
                disruptor-svg="one-hour-free-badge"
            />
        </section>

        <v-container class="container--slim">
            <SwitchLinks class="section" />

            <FinanceInfo class="section" />

            <Timeline class="section" :timeline="dataTimelineFinance" />

            <FinanceSupport
                class="section section--doubleSpacing section--dividerBottom"
            />

            <CallCard class="section" />
        </v-container>

        <Prefooter>
            <template v-slot:left>
                <RelatedArticle :article="dataRelatedArticle" />
            </template>
            <template v-slot:right>
                <PostcodeSearch />
            </template>
        </Prefooter>
    </div>
</template>

<script>
import SwitchLinks from '@/components/molecules/switch/links.vue'
import HeroBanner from '@/components/organisms/heroBanner/wide.vue'
import Timeline from '@/components/organisms/timeline.vue'
import MessageAlert from '@/components/organisms/messageAlert.vue'
import FinanceInfo from '@/components/organisms/financeInfo.vue'
import FinanceSupport from '@/components/organisms/financeSupport.vue'
import CallCard from '@/components/organisms/CallCard.vue'
import Prefooter from '@/components/organisms/footer/Prefooter.vue'
import PostcodeSearch from '@/components/molecules/prefooter/postcodeSearch.vue'
import RelatedArticle from '@/components/molecules/prefooter/relatedArticle.vue'
import TimelineStep from '@/components/molecules/timeline/timelineStep.vue'
import TimelineHeader from '@/components/molecules/timeline/timelineHeader.vue'

export default {
    name: 'NativePflegekasse',
    path: 'preis/pflegekasse',
    layout: 'native',

    components: {
        SwitchLinks,
        HeroBanner,
        Timeline,
        MessageAlert,
        FinanceInfo,
        FinanceSupport,
        CallCard,
        Prefooter,
        PostcodeSearch,
        RelatedArticle,
    },

    data: () => ({
        dataHeroBanner: {
            header: 'Preise & Pflegekasse',
            image: 'heroBanner/_SGA6712-Bearbeitet',
        },
        dataTimelineFinance: [
            {
                wide: true,
                image: 'graphics/scene-office-desk.png',
            },
            {
                highlight: true,
                icon: 'icon-charge',
                contentComponent: TimelineHeader,
                contentProps: {
                    header: 'Transparente Abrechnung',
                },
            },
            {
                contentComponent: TimelineStep,
                contentProps: {
                    label: '1',
                    header:
                        'Buchen Sie Ihre Alltagshilfe stundenweise mit Careship.',
                    text:
                        'Individuell abgestimmt mit Ihrem persönlichen Alltagshelfer',
                },
            },
            {
                dashed: true,
                contentComponent: TimelineStep,
                contentProps: {
                    label: '2',
                    header:
                        'Begleichen Sie die monatliche Rechnung ganz einfach per Überweisung.',
                    text:
                        'Monatliche Rechnung inkl. Übersicht aller geleisteten Stunden und Überweisung direkt an Ihren Alltagshelfer',
                },
            },
            {
                dashed: true,
                highlight: true,
                image: 'graphics/scene-mail-delivery.png',
                icon: 'business-contract-approve',
                contentComponent: TimelineHeader,
                contentProps: {
                    header: 'Rückerstattung über Verhinderungspflege',
                },
            },
            {
                contentComponent: TimelineStep,
                contentProps: {
                    label: '3',
                    header:
                        'Reichen Sie die Rechnung bei Ihrer Pflegekasse ein.',
                    text:
                        'Careship Rechnungen sind offiziell von allen Pflegekassen anerkannt',
                },
            },
            {
                contentComponent: TimelineStep,
                contentProps: {
                    label: '4',
                    header:
                        'Erhalten Sie das Geld für die bezahlten Leistungen von der Pflegekasse zurück.',
                    text:
                        'Die Erstattung dauert im Durchschnitt 2 bis 4 Wochen',
                },
            },
        ],
        dataRelatedArticle: {
            title: 'So können Sie Careship Leistungen von der Steuer absetzen',
            text:
                'Wie Sie Ihre jährliche Steuerschuld um bis zu 4.000 Euro mindern.',
            ctaText: 'Mehr zur Steuerentlastung',
            ctaLink: '/senioren-ratgeber/leistungen-von-der-steuer-absetzen/',
            image: 'heroBanner/shutterstock_745519105',
        },
        dataUSPList: {
            title: 'Unterstützung, die sich Ihnen anpasst ',
            ctaLink: '',
            ctaText: 'Leistungen im Überblick',
            list: [
                {
                    header: 'Keine Vertragsbindung',
                    text:
                        'Sie zahlen nur die Stunden, die Sie auch tatsächlich in Anspruch genommen haben.',
                    icon: 'calendar-clock',
                },
                {
                    header: 'Alle Leistungen, ein Preis',
                    text:
                        'Ob Hausarbeit, Erledigungen oder Begleitung - der Stundenpreis ist immer gleich.',
                    icon: 'icon-charge',
                },
                {
                    header: 'Erstattung über Pflegekasse',
                    text:
                        'Holen Sie sich entsprechend Ihren Ansprüchen Ihre Ausgaben von der Pflegekasse zurück.',
                    icon: 'business-contract-approve',
                },
            ],
        },
    }),

    head() {
        return {
            title: 'Finanzierung von Alltagshelfern | Careship',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content:
                        'Sie haben einen Pflegegrad und bekommen Leistungen aus der Pflegeversicherung? Erfahren Sie hier, wie Sie die Leistungen von Careship über Ihrer Pflegekasse finanzieren können.',
                },
            ],
        }
    },
}
</script>
